import { Component, OnInit, ViewChild } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { CartItem } from 'src/app/modals/cart-item';
import { CartService } from '../services/cart.service';
import { SidebarMenuService } from '../sidebar/sidebar-menu.service';
import { AppSettings, Settings } from '../services/color-option.service';
import { SidenavMenu } from '../../shared/sidebar/sidebar-menu.model';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { filterHeaderProducts } from './header.pipe';
import { HostListener } from '@angular/core';
import { ProductService } from '../services/product.service'
import { Info } from '../../../modals/info.model';
import { InfoService } from '../services/info.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public sidenavMenuItems:Array<any>;
  @ViewChild('start') sidenav: MatSidenav;
  

  public currencies = ['USD', 'EUR'];
  public currency:any;
  public displayProductsWrap: Boolean = false;
  public flags = [
    { name:'English', image: 'assets/images/flags/gb.svg' },
    { name:'German', image: 'assets/images/flags/de.svg' },
    { name:'French', image: 'assets/images/flags/fr.svg' },
    { name:'Russian', image: 'assets/images/flags/ru.svg' },
    { name:'Turkish', image: 'assets/images/flags/tr.svg' }
  ]
  public flag:any;
  infos:Info | null=null;
  products: Product[];

  indexProduct: number;
  shoppingCartItems: CartItem[] = [];
  public settings: Settings;
  public filterHeaderProducts = new filterHeaderProducts();
  navItems: SidenavMenu[] = [
    {
      displayName: 'Početna',
          iconName: 'feedback',
          route: '/home/three'
    },
    {
      displayName: 'Artikli',
          iconName: 'feedback',
          route: '/home/products/all/left-sidebar'
    },
   // {
   //   displayName: 'Blog',
   //       iconName: 'feedback',
   //       route: '/blog/blog-column'
   // },
    {
      displayName: 'O nama',
          iconName: 'feedback',
          route: '/pages/about'
    },
    {
      displayName: 'Česta pitanja',
          iconName: 'feedback',
          route: '/pages/faq'
    },
    {
      displayName: 'Projekti',
          iconName: 'feedback',
          route: '/pages/testimonials'
    },
    {
      displayName: 'Kontakt',
          iconName: 'feedback',
          route: '/pages/contact'
    }
  ];
  
  constructor(private cartService: CartService, public appSettings:AppSettings,private _router:Router,private productService:ProductService,private infoService:InfoService) {
    this.settings = this.appSettings.settings;
    this.cartService.getItems().subscribe(shoppingCartItems => this.shoppingCartItems = shoppingCartItems);
  }
  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.handleEnterClick();
    }
  }
  ngOnInit() {
    this.currency = this.currencies[0];
    this.flag = this.flags[0];

    this.productService.getProducts()
    .subscribe(
      (product: Product[]) => {
        this.products = product;
        this.filteredList = product;
      }
    )  
    this.infoService.getInfo().subscribe((info: Info) => {
      this.infos = info;
    });
  }

  public changeCurrency(currency){
    this.currency = currency;
  }
  public changeLang(flag){
    this.flag = flag;
  }

  public filteredList: Product[] = [];
  searchValue: string;
  public  handleSearchInput(event) {
    this.searchValue = event.target.value;
    this.filteredList = this.products.filter((product) => {
      const name = product.name?.toLocaleLowerCase();
      
      return this.searchValue === '' || name.indexOf(this.searchValue.toLocaleLowerCase()) > -1;
    });
    //console.log('this.filteredList', this.filteredList);
  }


  public handleEnterClick() {
 
    this._router.navigate(['/home/products/all/left-sidebar'], { 
      queryParams: {
        searchParameter: this.searchValue
      }
    });
    
  }

  public hideProductsModal() {
    setTimeout(() => { this.displayProductsWrap = false; }, 200);
  }
}
